
        <div class="relative" cdkOverlayOrigin #origin="cdkOverlayOrigin" #originEl>
            <button
                type="button"
                class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 pr-9 text-left text-slate-900 shadow-sm focus:border-[#6e9bad] focus:outline-none disabled:cursor-not-allowed disabled:opacity-60"
                [disabled]="disabled"
                (click)="togglePanel()"
                (blur)="onTouched()"
                [attr.aria-expanded]="panelOpen"
                aria-haspopup="listbox"
            >
                <span class="flex min-w-0 items-center gap-2">
                    <span *ngIf="selectedCountry" class="inline-flex h-5 w-5 shrink-0 items-center justify-center text-base leading-none" aria-hidden="true">
                        {{ selectedCountry.flag }}
                    </span>
                    <span class="truncate" [class.text-slate-400]="!value">
                        {{ triggerLabel() }}
                    </span>
                </span>
            </button>
            <span class="pointer-events-none absolute inset-y-0 right-3 flex items-center text-slate-400">▼</span>

            <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="origin"
                [cdkConnectedOverlayOpen]="panelOpen"
                [cdkConnectedOverlayHasBackdrop]="true"
                [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
                [cdkConnectedOverlayPositions]="overlayPositions"
                [cdkConnectedOverlayMinWidth]="originWidth"
                (backdropClick)="closePanel()"
                (detach)="closePanel()"
            >
                <div
                    class="w-full max-w-[calc(100vw-2rem)] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-[0_18px_40px_rgba(15,23,42,0.18)]"
                >
                    <div class="p-2">
                        <input
                            #searchInput
                            type="text"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-900 placeholder:text-slate-400 focus:border-[#6e9bad] focus:outline-none"
                            placeholder="Search country..."
                            [value]="searchQuery"
                            (input)="onSearch($any($event.target)?.value)"
                            (keydown.escape)="closePanel()"
                            (keydown.enter)="selectFirstFiltered()"
                        />
                    </div>
                    <div class="max-h-72 overflow-auto py-1" role="listbox">
                        <button
                            type="button"
                            *ngIf="allowEmpty && !searchQuery"
                            class="flex w-full items-center gap-2 border-b border-slate-100 px-3 py-2 text-left text-sm font-semibold text-slate-700 hover:bg-slate-50"
                            [class.bg-slate-50]="!value"
                            (click)="clearSelection()"
                        >
                            <span class="inline-flex h-5 w-5 shrink-0 items-center justify-center text-base leading-none" aria-hidden="true">🌍</span>
                            <span class="min-w-0 flex-1 truncate">{{ emptyLabel }}</span>
                        </button>
                        <button
                            type="button"
                            *ngFor="let country of filteredCountries; trackBy: trackCountryCode"
                            class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-50"
                            [class.bg-slate-50]="country.code === value"
                            (click)="selectCountry(country.code)"
                        >
                            <span class="inline-flex h-5 w-5 shrink-0 items-center justify-center text-base leading-none" aria-hidden="true">
                                {{ country.flag }}
                            </span>
                            <span class="min-w-0 flex-1 truncate">{{ country.name }}</span>
                            <span class="shrink-0 text-xs text-slate-500">{{ country.code }}</span>
                        </button>
                        <div *ngIf="filteredCountries.length === 0" class="px-3 py-2 text-sm text-slate-500">
                            No countries found.
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    
